<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">Affiliate Reports</h3>
            <small class="text-muted">
              Affiliate performance and commission tracking
            </small>
          </div>

          <div class="d-flex align-items-center">
            <b-button variant="primary" class="text-nowrap" size="sm">
              <feather-icon icon="DownloadIcon" />
              Export
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted"> Active Affiliates </span>
              <h3 class="font-weight-bolder">45</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted"> Total NGR </span>
              <h3 class="font-weight-bolder">$456K</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Commissions Due</span>
              <h3 class="font-weight-bolder">$54.7K</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Referred Customers</span>
              <h3 class="font-weight-bolder">1,234</h3>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12">
        <b-card class="shadow-sm">
          <h5 class="font-weight-bolder">Affiliate Reports</h5>
          <div
            v-for="(file, index) in reports"
            :key="index"
            class="report-item"
          >
            <div class="d-flex align-items-center">
              <div class="excel-icon mr-1">
                <feather-icon
                  icon="FileTextIcon"
                  size="16"
                  class="text-warning"
                />
              </div>

              <div class="flex-grow-1">
                <div class="font-weight-semibold">
                  {{ file.name }}
                </div>
                <small class="text-muted">
                  {{ file.sub }}
                </small>
              </div>

              <b-button size="sm" variant="outline-secondary" class="mr-1">
                <feather-icon icon="EyeIcon" size="14" />
                View
              </b-button>
              <b-button size="sm" variant="primary">
                <feather-icon icon="DownloadIcon" size="14" />
                Download
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
  BLink,
  BTable,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
    BLink,
    BTable,
    FeatherIcon,
  },
  data() {
    return {
      reports: [
        {
          name: "affiliate_performance_january_2026.xlsx",
          sub: "MTD performance by affiliate",
        },
        {
          name: "ffiliate_commissions_january_2026.xlsx",
          sub: "Commission calculations",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.report-item {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
}

.report-item:last-child {
  border-bottom: none;
}

.excel-icon {
  width: 36px;
  height: 36px;
  background: #fef3c7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>